/* sr-toast-accent.js — flags the .sr-toast as add (green) or remove (red)
   based on whether the cart item_count went up or down. The toast itself is
   built in sr-theme.js; here we only add a class + relabel on removal. */
(function () {
  var last = null;
  function toast() {
    return document.querySelector('.sr-toast');
  }
  function flag(action) {
    var t = toast();
    if (!t) return;
    if (action === 'remove') {
      t.classList.add('sr-toast--removed');
      t.classList.remove('sr-toast--added');
      var lbl = t.querySelector('.sr-toast__label');
      if (lbl) lbl.textContent = 'Removed from cart';
    } else {
      t.classList.add('sr-toast--added');
      t.classList.remove('sr-toast--removed');
    }
  }
  // Primary signal: watch cart count deltas via Alpine store / global cart.
  function poll() {
    try {
      var c = window.cart && typeof window.cart.item_count === 'number' ? window.cart.item_count : null;
      if (c !== null) {
        if (last !== null && c !== last) flag(c < last ? 'remove' : 'add');
        last = c;
      }
    } catch (e) {}
  }
  document.addEventListener('cart:updated', poll, true);
  document.addEventListener('cart:refresh', poll, true);
  // Fallback signal: tile +/- buttons and PDP add.
  document.addEventListener('click', function (e) {
    var dec = e.target.closest && e.target.closest('[data-d="-1"], [aria-label*="Decrease" i]');
    if (dec) { flag('remove'); return; }
    var inc = e.target.closest && e.target.closest('[data-d="1"], [aria-label*="Increase" i], [aria-label*="Add" i], button[name="add"]');
    if (inc) flag('add');
  }, true);
  // Light interval to catch store mutations Alpine doesn't event out.
  setInterval(poll, 600);
})();
